import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import CompanyDetailsComponent from "../components/master-staff/CompanyDetailsComponent";

const CompanyDetailsPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Company Details"
        routes={[
          { title: "Home", path: "/" },
        ]}
      />
      <CompanyDetailsComponent />
    </>
  );
};

export default CompanyDetailsPage;
